import { FetchBaseQueryError } from '@reduxjs/toolkit/query'

import { clearAuthStorage } from '@/utils/storage/adapters/localStorageAdapter'

export function handleTransformErrorResponse(error: FetchBaseQueryError): FetchBaseQueryError {
  if (error && 'status' in error && (error.status === 401 || error.status === 403)) {
    clearAuthStorage()
    location.href = '/login'
  }
  return error
}
